import { useEffect } from "react"
import { useModal } from "../../../contexts/Modal"
import { useData } from "../../../contexts/Data"
import WriteAlliance from "../../modals/WriteAlliance/WriteAlliance"
import koalition from "../../../api/koalition"

const Alliances = ({}) => {
    const modal = useModal()
    const data = useData()

    const onNewAllianceClick = () => {
        modal.open({ title: 'New Alliance', component: <WriteAlliance /> })
    }

    const onAllianceClick = (alliance) => {
        modal.open({ title: 'Edit Alliance', component: <WriteAlliance />, data: { alliance } })
    }

    useEffect(() => {
        if (!data.$state.alliances) {
            koalition.get('/alliances').then((response) => {
                data.save('alliances', response.data)
            }).catch((error) => {
                console.error(error)
            })
        }
    }, [])

    return (
        <div className="alliances">
            <header className="container-fluid mb-5">
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <button className="primary large" onClick={onNewAllianceClick}>New Alliance</button>
                    </div>
                </div>
            </header>

            <main className="container-fluid">
                <ul className="row pr-4">
                    {data.$state.alliances?.map((alliance) => (
                        <li className="col-sm-6 col-xl-4 pr-0" key={alliance._id}>
                            <div className="card alliance flex-center-y justify-content-between cursor-pointer mb-4" onClick={() => onAllianceClick(alliance)}>
                                <span className="chip base tag mr-3">{alliance.tag}</span>
                                <span>{alliance.name}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </main>
        </div>
    )
}

export default Alliances